import { render, staticRenderFns } from "./qualityDetail.vue?vue&type=template&id=37870fa8&scoped=true"
import script from "./qualityDetail.vue?vue&type=script&lang=js"
export * from "./qualityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37870fa8",
  null
  
)

export default component.exports